var Widget          = require("./Widget");
var $               = require("jquery");
var Utils			= require('Utils');
var _               = require('underscore');

var defaultOptions = {
    /* Массив OMJS виджетов */
    elements: [],
    /* Иконка для дропдауна (false - дефолтная иконка) */
    icon: false,
    /* Обработчик события на клик по елементу выпадающего списка */
    onItemClick: false,
    /* Нужно ли закрывать выпадающий список после клика по элементу */
    shouldClose: false
};

/* 
	Компонент дропдауна
*/
var DropDown = Widget.extend({
    initialize: function(options){
        var that = this;
        options = $.extend({}, defaultOptions, (options || {}));
        DropDown.__super__.initialize.call(that, options);

        var $container = that.getContainer();

        that.list_hide_timeout	= null;
        that.view				= false;
        that.isTouch			= Utils.isTouch();
        that._opened			= false;

        $container = that.getContainer();
        $container.addClass('omjs-dropdown');

        that.$actionButton = $(that.generateActionButton());

        if (!that.isTouch) {
        	/* логика для десктопов */
        	$container.on('mouseenter', that.showContainer.bind(that));
        	$container.on('mouseleave', that.hideContainer.bind(that));
        } else {
        	/* логика для тач устройств */
        	that.$actionButton.on('focus', that.showContainer.bind(that));
			that.$actionButton.on('blur', that.hideContainer.bind(that));
        }
        

        that.$list = $(that.generateListWrapper());
        that.$list.append(
            that.generateListItems(that.options.elements)
        );

        $container.append(that.$actionButton, that.$list);
        
        that.setActionIcon();
    },

    onAdd: function(view){
    	var that = this;
    	that.view = view;
    	_.each(that.options.elements, function(widget){
    		widget.onAdd(view);
    	});
    },

    generateActionButton: function(){
    	var outerElement = document.createElement('div');
    		outerElement.className = 'action-button';

        // if (this.options.icon && _.isString(this.options.icon)) {
        //     outerElement.style.backgroundImage = 'url('+this.options.icon+')';
        // }

    	outerElement.setAttribute('tabindex', '0');

    	return outerElement;
    },

    setActionIcon: function(opt_icon){
        opt_icon = opt_icon || this.options.icon;
        if (opt_icon) {
         this.$actionButton.css({
             backgroundImage: 'url('+opt_icon+')'
         });
        }
    },

    generateListWrapper: function(){
    	var outerElement = document.createElement('div');
    		outerElement.className = 'expandable-list';

    	return outerElement;
    },

    generateListItems: function(widgets){
    	var that = this;
    	var _containers = [];
    	var listContainers = _.map(widgets, function(widg){
    		_containers.push(widg.getContainer());
    		return {
    			widget: widg,
    			container: widg.getContainer()
    		};
    	});

    	_.each(listContainers, function(cont){
    		cont.container.on(
    			'click', 
    			that.__onItemClick__.bind(that, cont.widget)
    		);
    	});

    	return _containers;
    },

    __onItemClick__: function(clicked_widget, jQueryEvent){
    	var that = this;

    	if (
    		that.options.onItemClick 
    		&& _.isFunction(that.options.onItemClick)
    	) {
    		that.options.onItemClick(clicked_widget, jQueryEvent);
    	}

    	if (that.options.shouldClose) {
    		that.hideContainer();
    	}
    	that.fire('item_click', {
    		item: clicked_widget,
    		event: jQueryEvent
    	});
    },

    showContainer: function(){
    	var that = this;
    	if (that.list_hide_timeout) clearTimeout(that.list_hide_timeout);
		// console.log(that.$list.parents('.dark-tools-control'));
		var left = parseInt(that.$list.parents('.dark-tools-control').offset().left);
		var right;
		if(parseInt($(window).width()) - left < parseInt(that.$list.width())){
			right = 10;
			left = undefined;
		}
		that.$list.css({
			'position': 'fixed',
			'left': left + 'px',
			'right': right + 'px'
		});
		that.$list.show();
    	that._opened = true;
    },

    hideContainer: function(){
    	var that = this;
    	that.list_hide_timeout = setTimeout(function(){
    		that.$list.hide();
    		that.list_hide_timeout = null;
    		that._opened = false;
    	}, 70);
    }
});

module.exports = DropDown;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/DropDown.js
// module id = 201
// module chunks = 0